import Vue from 'vue'
import Router from 'vue-router'

import { getToken } from '@/utils/auth'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
// Views
const Dashboard = () => import('@/views/Dashboard')
const Rfb3 = () => import('@/views/Rfb3')
const Notification = () => import('@/views/Notification')

// const RequestBookAll = () => import('@/views/requestbook/All')
const RequestBook = () => import('@/views/RequestBook')

const ManagementBook = () => import('@/views/management/Book')
const ManagementArticle = () => import('@/views/management/Article')
const ManagementExport = () => import('@/views/management/Export')
const ManagementBookCategory = () => import('@/views/management/BookCategory')
const ManagementArticleCategory = () =>
  import('@/views/management/ArticleCategory')
const ManagementUser = () => import('@/views/management/User')
const ManagementComment = () => import('@/views/management/Comment')

const ConvertBook = () => import('@/views/convert/Book')
const ConvertArticle = () => import('@/views/convert/Article')

const ReportUserLog = () => import('@/views/report/UserLog')
const ReportRequestBook = () => import('@/views/report/RequestBook')
const ReportBook = () => import('@/views/report/Book')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (getToken() == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

function configRoutes() {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'หน้าหลัก',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'rfb3',
          name: 'Rfb3',
          component: Rfb3,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'notification',
          name: 'Notification',
          component: Notification,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'requestbook',
          name: 'RequestBook',
          component: RequestBook,
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: 'requestbook',
        //   name: 'Notification',
        //   component: {
        //     render (c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: 'all',
        //       name: 'RequestBookAll',
        //       component: RequestBookAll
        //     },
        //     {
        //       path: 'new',
        //       name: 'RequestBookNew',
        //       component: RequestBookNew
        //     }
        //   ]
        // },
        {
          path: 'management',
          name: 'Management',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'book',
              name: 'ManagementBook',
              component: ManagementBook,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'article',
              name: 'ManagementArticle',
              component: ManagementArticle,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'export',
              name: 'ManagementExport',
              component: ManagementExport,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'book_category',
              name: 'ManagementBookCategory',
              component: ManagementBookCategory,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'article_category',
              name: 'ManagementArticleCategory',
              component: ManagementArticleCategory,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'user',
              name: 'ManagementUser',
              component: ManagementUser,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'comment',
              name: 'ManagementComment',
              component: ManagementComment,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: 'convert',
          name: 'Convert',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'book',
              name: 'ConvertBook',
              component: ConvertBook,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'article',
              name: 'ConvertArticle',
              component: ConvertArticle,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: 'report',
          name: 'Report',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'user_log',
              name: 'ReportUserLog',
              component: ReportUserLog,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'request_book',
              name: 'ReportRequestBook',
              component: ReportRequestBook,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'book',
              name: 'ReportBook',
              component: ReportBook,
              meta: {
                requiresAuth: true
              }
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

export default router
